import { useSelector } from 'react-redux';

import SpinnerOverlay from 'components/SpinnerOverlay';

import { SiteHeader } from '../components/site/site-header';
import { SiteFooter } from '../components/site/site-footer';

import '../styles/marketing.css';

// Shell for the public marketing pages (replaces the dashboard AppContainer/AppHeader).
// `.mk-root` scopes every marketing style - see tailwind.marketing.config.js.
function MarketingLayout({ children }) {
	const { isLoadingAddress, isLoadingProperty } = useSelector((state) => ({
		isLoadingAddress: state.address.isLoading,
		isLoadingProperty: state.property.isLoading,
	}));

	let spinnerText = '';
	if (isLoadingAddress) {
		spinnerText = 'Checking Address...';
	} else if (isLoadingProperty) {
		spinnerText = 'Loading Property...';
	}

	return (
		<div className="mk-root flex min-h-screen flex-col">
			<SiteHeader />
			<SpinnerOverlay
				text={spinnerText}
				isLoading={isLoadingAddress || isLoadingProperty}
			/>
			<main className="flex-1">{children}</main>
			<SiteFooter />
		</div>
	);
}

export default MarketingLayout;
